import { Component, OnInit } from '@angular/core';
import { GbgrundstueckService } from '../../../core/gb-api';
import { ActivatedRoute, Router } from '@angular/router';
import { GrundpfandrechtViewmodelService, RootBelastungVm } from '../../../core/services/grundpfandrecht-viewmodel.service';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { ListLoaderObservable } from '../../../shared/components/list-loader/list-loader-observable';
import { AbstractGrundstueckEntryFromRoute } from '../abstract-grundstueck-entry-from.route';
import { TimepointService } from '../../../core/services/timepoint.service';
import { AppConfigService } from '../../../core/services/app-config.service';
import { map, tap } from 'rxjs/operators';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { GrundpfandrechtTableComponent } from '../../../shared/widgets/grundpfandrecht-table/grundpfandrecht-table.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-grundpfandrecht-rubrik-rubrik',
  templateUrl: './grundstueck-grundpfandrechte-rubrik.component.html',
  styleUrls: ['./grundstueck-grundpfandrechte-rubrik.component.scss'],
  imports: [RubrikComponent, GrundpfandrechtTableComponent, TranslatePipe]
})
export class GrundstueckGrundpfandrechteRubrikComponent extends AbstractGrundstueckEntryFromRoute implements OnInit {
  public listLoader: ListLoader<RootBelastungVm>;
  public ersterfassungUebergeben;

  constructor(
    private grundpfandrechtViewmodelService: GrundpfandrechtViewmodelService,
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected router: Router
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected loadData() {
    const observable = this.grundpfandrechtViewmodelService.loadSichtByGbGrundstueckId(this.gsId).pipe(
      tap((resp) => (this.ersterfassungUebergeben = resp.ersterfassungUebergeben)),
      map((res) => res.entries)
    );
    this.listLoader = new ListLoaderObservable<RootBelastungVm>(undefined, 1, observable);
    this.addLoader(this.listLoader);
  }
}
